module.exports = __webpack_public_path__ + "img/jf_home_09.c6ee42ed.jpg";